import * as React from 'react';

import { Grid } from '@coursera/cds-core';
import { StyleSheet, css } from '@coursera/coursera-ui';

import PrimaryButtonContentful from 'bundles/coursera-plus-landing-page/components/ctaContentful/PrimaryButtonContentful';
import { CTA_LOCATIONS, PRESENTATIONS } from 'bundles/coursera-plus-landing-page/contentful/constants';
import { BASE_STYLES } from 'bundles/design-system/components/container-styles';

const styles = StyleSheet.create({
  container: {
    ...BASE_STYLES.container,
  },
  mobileCta: {
    borderRadius: '0 !important',
    width: '100% !important',
    margin: '12px 0',
    padding: '12px !important',
    fontSize: '14px !important',
    lineHeight: '14px !important',
    minHeight: 'auto !important',
  },
});

const StickyContentMobile: React.FC<{}> = () => (
  <Grid className={css(styles.container).className}>
    <div style={{ marginTop: '10px' }} />
    <PrimaryButtonContentful
      ctaLocation={CTA_LOCATIONS.sticky}
      presentation={PRESENTATIONS.bigButton}
      singleBigButton={true}
      rootClassName={css(styles.mobileCta).className}
      isFirstCheckoutInHero={false}
    />
  </Grid>
);

export default StickyContentMobile;
